import { render } from "./data-client.vue?vue&type=template&id=db72d9d2"
import script from "./data-client.vue?vue&type=script&lang=js"
export * from "./data-client.vue?vue&type=script&lang=js"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__